/**
 * SearchSuggestion class to handle rendering and interaction with search suggestions
 */
class SearchSuggestion {
    /**
     * Create a SearchSuggestion instance
     * @param {string} containerId - The ID of the container element
     */
    constructor(containerId) {
        this.container = document.getElementById(containerId);
        this.activeSuggestion = null;
    }

    /**
     * Clear the container content
     */
    clearContainer() {
        if (this.container) {
            this.container.innerHTML = '';
        }
    }

    /**
     * Render search suggestions
     * @param {Array} data - Array of suggestion items
     * @param {boolean} isTrending - Whether these are trending suggestions
     */
    render(data, isTrending = false) {
        if (!this.container || !data || data.length === 0) {
            return;
        }

        this.clearContainer();

        // Use DocumentFragment for better performance
        const fragment = document.createDocumentFragment();

        // Add trending title if needed
        if (isTrending) {
            const trendingTitle = document.createElement('h3');
            trendingTitle.textContent = 'Trending Searches:';
            fragment.appendChild(trendingTitle);
        }

        // Filter out invalid items
        const validItems = data.filter(item => item && item.name);

        // Create suggestion elements
        validItems.forEach((item, index) => {
            const suggestionElement = document.createElement('button');
            suggestionElement.classList.add('flex-suggestion-item');

            const heading = document.createElement('h5');
            heading.textContent = item.name;
            suggestionElement.appendChild(heading);

            // Add click handler
            suggestionElement.addEventListener('click', this.createSuggestionClickHandler(
                suggestionElement, item.name
            ));

            fragment.appendChild(suggestionElement);

            // Mark first item as active if not trending
            if (index === 0 && !isTrending) {
                // Format first suggestion (the search query)
                heading.innerHTML = `<small style="opacity: 0.5;">Searched:</small><br />${item.name}`;
                suggestionElement.classList.add('active');
                this.activeSuggestion = suggestionElement;
            }
        });

        this.container.appendChild(fragment);
    }

    /**
     * Create a click handler for suggestion items
     * @param {HTMLElement} element - The suggestion element
     * @param {string} query - The suggestion query text
     * @returns {Function} - Click event handler
     */
    createSuggestionClickHandler(element, query) {
        return async () => {
            try {
                // Update the global parameters
                window.updateAutocompleteParams({
                    q: query
                });

                // Update active suggestion UI
                if (this.activeSuggestion) {
                    this.activeSuggestion.classList.remove('active');
                }
                element.classList.add('active');
                this.activeSuggestion = element;

                // Query using the updated global parameters
                await window.queryAutocomplete();

            } catch (error) {
                console.error('Error handling suggestion click:', error);
            }
        };
    }
}

window.SearchSuggestion = SearchSuggestion;